import React, { useState, useEffect } from "react";
import moment from "moment";
import { getBids } from "../lib/auctions";
import { getContinuousPurchasePrice } from "../lib/auctions/gda/continuous";
import { getDiscretePurchasePrice } from "../lib/auctions/gda/discrete";
import { ASCENDING, GDA_CONTINUOUS, GDA_DISCRETE } from "../utils";

const NormalAuction = ({
  shopId,
  productId,
  now,
  endEpoch,
  onPlaceBid,
  customerId,
  shopLoginUrl,
}) => {
  const [statefulBids, setStatefulBids] = useState([]);

  const [timeLeft, setTimeLeft] = useState(
    endEpoch > now
      ? moment(endEpoch * 1000).unix() - moment(now * 1000).unix()
      : 0
  );

  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        if (timeLeft % 2 === 0) {
          // fetch new bids
          /*
          const _bids = await getBids({ shopId, productId });
          setStatefulBids(_bids);
          */
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, shopId, productId]);

  const [bidAmount, setBidAmount] = useState("0.00");

  return (
    <div>
      {/* meta container */}
      <p className="text-base  opacity-50">Current bid:</p>
      <h1 className="text-4xl 5xl:text-5xl font-medium">
        {statefulBids.length > 0
          ? statefulBids.reduce(function (prev, current) {
              return prev.price > current.price ? prev : current;
            }).price
          : 0}{" "}
        USD
      </h1>
      <div className="mt-5">
        {timeLeft === 0 && <p className=" ">Auction has ended.</p>}
        {timeLeft > 0 && (
          <p className="text-base">
            Auction ends in {moment.duration(timeLeft, "seconds").humanize()}
          </p>
        )}
        <p className="text-base">{statefulBids.length} bids</p>
        <p className="text-base">225 Watchers, 17k views</p>
      </div>
      {/* price div */}
      <div className="mt-5" style={{ display: "flex", flexDirection: "row" }}>
        <div
          className={
            "rounded-lg border border-[#BFBFBF] flex flex-row items-center px-5 py-3 w-full justify-between relative bg-white"
          }
        >
          <form>
            <input
              type="decimal"
              value={String(bidAmount)}
              onChange={(e) => {
                let _bidAmount = e.target.value;
                if (_bidAmount.includes(".")) {
                  if (_bidAmount.split(".")[1].length > 2) return;
                  setBidAmount(_bidAmount);
                } else {
                  setBidAmount(_bidAmount);
                }
              }}
              className="w-full text-2xl outline-none ring-0 focus:outline-none placeholder:text-[#ABABAB]"
            />
          </form>
          <button
            disabled={
              (Number(bidAmount) > 0
                ? statefulBids.length > 0
                  ? statefulBids.reduce(function (prev, current) {
                      return prev.price > current.price ? prev : current;
                    }).price
                  : 0 > Number(bidAmount)
                : true) ||
              // placingBid ||
              // !customerId ||
              timeLeft === 0
            }
            onClick={
              customerId
                ? () => onPlaceBid(Number(bidAmount))
                : () => {
                    console.log(shopLoginUrl);
                    window.open(shopLoginUrl, "_blank");
                  }
            }
            theme={"solid-dark"}
          >
            {timeLeft === 0 ? "Ended" : customerId ? "Place Bid" : "Log In"}
          </button>
        </div>
      </div>
      {/* terms */}
      <div className="mt-5">
        <p className="text-base opacity-50">Minimum bid increment: $100</p>
        <p className="text-base opacity-50">
          By placing your bid, you’re committing to buy this item if you win the
          auction.
        </p>
        <p className="text-base opacity-50">
          If you’re not ready to bid, click to get email updates on this
          auction.
        </p>
      </div>
    </div>
  );
};

const GDAContinuous = ({
  auction,
  now,
  customerId,
  shopLoginUrl,
  onPlaceBid,
  currentPrice,
  setCurrentPrice,
}) => {
  const [purchaseQuantity, setPurchaseQuantity] = useState(1);

  const [loggedIn, setLoggedIn] = useState(false);

  const [timeLeft, setTimeLeft] = useState(now);

  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        if (timeLeft % 2 === 0) {
          const epoch = new Date().getTime() / 1000;
          const price = getContinuousPurchasePrice(
            auction.starting_price,
            auction.decay_rate,
            auction.emission_rate,
            Math.floor(epoch) - auction.last_epoch,
            purchaseQuantity === "" ? 1 : Number(purchaseQuantity)
          );
          setCurrentPrice(price);
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, auction, setCurrentPrice, purchaseQuantity]);

  return (
    <div>
      {/* meta container */}
      <p className="text-base  opacity-50">Current Price:</p>
      <h1 className="text-4xl 5xl:text-5xl font-medium">
        {currentPrice.toFixed(2)} USD
      </h1>
      <div className="mt-5">
        <p className="text-base">225 Watchers, 17k views</p>
      </div>
      {/* price div */}
      <div className="flex flex-row mt-5">
        <div className="rounded-lg border border-[#BFBFBF] flex flex-row items-center px-5 py-3 w-full justify-between relative bg-white">
          <form>
            <input
              disabled={customerId ? false : true}
              type="number"
              className="w-full text-2xl outline-none ring-0 focus:outline-none placeholder:text-[#ABABAB]"
              value={purchaseQuantity}
              onChange={(e) => {
                let _purchaseQuantity = e.target.value;
                setPurchaseQuantity(_purchaseQuantity);
              }}
            />
          </form>
          <button
            disabled={customerId ? false : loggedIn ? true : false}
            onClick={
              customerId
                ? () => onPlaceBid(purchaseQuantity)
                : () => {
                    setLoggedIn(true);
                    window.open(shopLoginUrl, "_blank");
                  }
            }
            theme={"solid-dark"}
          >
            {customerId ? "Purchase" : "Log In"}
          </button>
        </div>
      </div>
    </div>
  );
};

const GDADiscrete = ({
  auction,
  now,
  customerId,
  shopLoginUrl,
  onPlaceBid,
  currentPrice,
  setCurrentPrice,
}) => {
  // const [currentPrice, setCurrentPrice] = useState(0);
  const [purchaseQuantity, setPurchaseQuantity] = useState(1);

  const [loggedIn, setLoggedIn] = useState(false);

  const [timeLeft, setTimeLeft] = useState(now);

  useEffect(() => {
    if (timeLeft > 0) {
      let refresh = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
        if (timeLeft % 2 === 0) {
          const price = getDiscretePurchasePrice(
            auction.starting_price,
            auction.decay_rate,
            auction.scale_factor,
            auction.sold,
            new Date().getTime() / 1000 - auction.start_epoch,
            purchaseQuantity === "" ? 1 : Number(purchaseQuantity)
          );
          setCurrentPrice(price);
        }
      }, 1000);
      return () => clearTimeout(refresh);
    }
  }, [timeLeft, auction, purchaseQuantity, setCurrentPrice]);

  return (
    <div>
      {/* meta container */}
      <p className="text-base  opacity-50">Current Price:</p>
      <h1 className="text-4xl 5xl:text-5xl font-medium">
        {currentPrice.toFixed(2)} USD
      </h1>
      <div className="mt-5">
        <p className="text-base">
          {auction.sold}/{auction.quantity} Sold
        </p>
        <p className="text-base">225 Watchers, 17k views</p>
      </div>
      {/* price div */}
      <div className="flex flex-row mt-5">
        <div className="rounded-lg border border-[#BFBFBF] flex flex-row items-center px-5 py-3 w-full justify-between relative bg-white">
          <form>
            <input
              disabled={customerId ? false : true}
              type="number"
              className="w-full text-2xl outline-none ring-0 focus:outline-none placeholder:text-[#ABABAB]"
              value={purchaseQuantity}
              onChange={(e) => {
                let _purchaseQuantity = e.target.value;
                setPurchaseQuantity(_purchaseQuantity);
              }}
            />
          </form>
          <button
            disabled={customerId ? false : loggedIn ? true : false}
            onClick={
              customerId
                ? () => onPlaceBid(purchaseQuantity)
                : () => {
                    setLoggedIn(true);
                    window.open(shopLoginUrl, "_blank");
                  }
            }
            theme={"solid-dark"}
          >
            {customerId ? "Purchase" : loggedIn ? "Refresh Page" : "Log In"}
          </button>
        </div>
      </div>
    </div>
  );
};

export const PlaceBid = ({
  shopId,
  productId,
  auction,
  now,
  onPlaceBid,
  customerId,
  shopLoginUrl,
  statefulPrice,
  setStatefulPrice,
}) => {
  return (
    <>
      {auction.kind === ASCENDING.KIND && (
        <NormalAuction
          shopId={shopId}
          productId={productId}
          now={now}
          endEpoch={auction.end_epoch}
          onPlaceBid={onPlaceBid}
          customerId={customerId}
          shopLoginUrl={shopLoginUrl}
        />
      )}
      {auction.kind === GDA_CONTINUOUS.KIND && (
        <GDAContinuous
          auction={auction}
          now={now}
          customerId={customerId}
          shopLoginUrl={shopLoginUrl}
          onPlaceBid={onPlaceBid}
          currentPrice={statefulPrice}
          setCurrentPrice={setStatefulPrice}
        />
      )}
      {auction.kind === GDA_DISCRETE.KIND && (
        <GDADiscrete
          auction={auction}
          now={now}
          customerId={customerId}
          shopLoginUrl={shopLoginUrl}
          onPlaceBid={onPlaceBid}
          currentPrice={statefulPrice}
          setCurrentPrice={setStatefulPrice}
        />
      )}
    </>
  );
};
